import { FC, PropsWithChildren } from 'react';
import { useResetPasswordMutation } from '@/transport/gatewayApi';
import { UseDoResetPasswordMutationContext } from '@/bo-kit/components/ResetPasswordPage/components/CodeVerify/components/Form/hooks/useDoVerifyResetPassword';

export const UseDoResetPasswordMutationContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [doResetPassword, state] = useResetPasswordMutation();
    return (
        <UseDoResetPasswordMutationContext.Provider value={[doResetPassword, state]}>
            {children}
        </UseDoResetPasswordMutationContext.Provider>
    );
};
